import { Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { services } from "../../data/content";
import { ArrowRight } from "@phosphor-icons/react";

export const CoreServicesGrid = ({ dark = false }) => (
    <section className={`relative ${dark ? "bg-navy grain" : "bg-[#f8fafc]"}`} data-testid="core-services">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <SectionHeading
                dark={dark}
                overline="Our Core Services"
                title="End-to-end workforce & staffing services"
                subtitle="From contract staffing to complete project-based deployment — FRONTX supports every stage of your workforce lifecycle."
            />
            <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5 auto-rows-fr">
                {services.map((s, i) => {
                    const span = i === 0 || i === 3 ? "lg:col-span-6" : "lg:col-span-3";
                    const hasImg = !!s.image;
                    return (
                        <StaggerItem key={s.id} className={`${span} md:col-span-1`}>
                            <div className={`group relative h-full min-h-[240px] p-7 rounded-sm border overflow-hidden transition-transform duration-300 hover:-translate-y-1 ${
                                dark ? "bg-slate-800 border-white/10" : "bg-white border-slate-200"
                            }`}>
                                {hasImg && (
                                    <div className="absolute inset-0 z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                        <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                                        <div className="absolute inset-0 bg-navy/85" />
                                    </div>
                                )}
                                <div className="relative z-10 flex flex-col h-full">
                                    <div className="flex items-start justify-between">
                                        <s.icon size={36} weight="duotone" className={`${dark || hasImg ? "text-brand" : "text-brand"} ${hasImg ? "group-hover:text-white" : ""} transition-colors`} />
                                        <span className={`font-display font-extrabold text-3xl ${dark ? "text-white/10" : "text-navy/10"} ${hasImg ? "group-hover:text-white/20" : ""}`}>{s.letter}</span>
                                    </div>
                                    <h3 className={`mt-6 font-display font-bold text-xl tracking-tight ${dark ? "text-white" : "text-navy"} ${hasImg ? "group-hover:text-white" : ""}`}>{s.title}</h3>
                                    <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"} ${hasImg ? "group-hover:text-slate-200" : ""}`}>{s.desc}</p>
                                    <div className="mt-auto pt-5 flex flex-wrap gap-2">
                                        {s.items.slice(0, 4).map((it) => (
                                            <span key={it} className={`text-[11px] px-2.5 py-1 rounded-sm border ${
                                                dark ? "border-white/15 text-slate-300" : "border-slate-200 text-slate-500"
                                            } ${hasImg ? "group-hover:border-white/30 group-hover:text-white" : ""}`}>{it}</span>
                                        ))}
                                        {s.items.length > 4 && (
                                            <span className="text-[11px] px-2.5 py-1 text-brand font-semibold">+{s.items.length - 4} more</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </StaggerItem>
                    );
                })}
            </Stagger>
        </div>
    </section>
);
